module.exports = __webpack_public_path__ + "img/stepsThree.cddccc59.svg";